// Function index:
//   BillingEntitlements — entitlements response (subscription + items).
//   BillingProduct      — product/price row from /api/billing/products.
//   getBillingEntitlements() / listBillingProducts() — reads.
//   startBillingCheckout(priceId) / openBillingPortal() — return a redirect url.
//   confirmBilling(sessionId) — post-redirect confirm; returns entitlements.

import { getJson, postJson } from './http.js';

export interface BillingEntitlements {
  subscription: { plan_key: string; status: string; current_period_end: string | null } | null;
  items: string[];
}
export interface BillingProduct {
  price_id: string;
  kind: string;
  entitlement_key: string;
  unit_amount: number | null;
  currency: string;
  recurring: unknown | null;
}

export const getBillingEntitlements = (): Promise<BillingEntitlements> =>
  getJson<BillingEntitlements>('/api/billing/entitlements');
export const listBillingProducts = (): Promise<BillingProduct[]> =>
  getJson<BillingProduct[]>('/api/billing/products');
export const startBillingCheckout = (priceId: string): Promise<{ url: string }> =>
  postJson<{ url: string }>('/api/billing/checkout', { price_id: priceId });
export const openBillingPortal = (): Promise<{ url: string }> =>
  postJson<{ url: string }>('/api/billing/portal', {});
export const confirmBilling = (sessionId: string): Promise<BillingEntitlements> =>
  getJson<BillingEntitlements>(`/api/billing/confirm?session_id=${encodeURIComponent(sessionId)}`);
